import { Phone } from "lucide-react";
import { waLink, WA_DEFAULT_MSG, PHONE_LINK } from "@/lib/wa";
import { STR } from "@/data/i18n";
import { useLang } from "@/lib/lang";
import { WhatsAppIcon } from "./Shared";

export const MobileBottomBar = () => {
    const { lang } = useLang();
    return (
        <div
            data-testid="mobile-bottom-bar"
            className="fixed inset-x-0 bottom-0 z-50 border-t border-white/10 bg-[#0a0a0a]/90 backdrop-blur-xl md:hidden"
            style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
        >
            <div className="grid grid-cols-2 gap-3 px-4 py-3">
                <a
                    href={waLink(WA_DEFAULT_MSG)}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="mobile-bar-wa-button"
                    className="flex items-center justify-center gap-2 rounded-full bg-green-500 py-3.5 text-sm font-semibold text-white shadow-lg shadow-green-900/40 transition-transform duration-200 active:scale-95"
                >
                    <WhatsAppIcon className="h-4 w-4" />
                    WhatsApp
                </a>
                <a
                    href={PHONE_LINK}
                    data-testid="mobile-bar-phone-button"
                    className="flex items-center justify-center gap-2 rounded-full border border-white/15 bg-white/5 py-3.5 text-sm font-semibold text-slate-100 transition-colors duration-200 active:border-amber-400/60"
                >
                    <Phone className="h-4 w-4 text-amber-400" />
                    {STR.misc[lang].call}
                </a>
            </div>
        </div>
    );
};
